var path = 'areas/master/getting-started/views/getting_started_detail_section.html';
var html = "<span class=section> <div class=complete><i class=\"fa fa-check\" aria-hidden=true></i></div> <div class=top> <img ng-src={{imgSrc}} height=50 alt={{area}} /> <div>{{header}}</div> <div class=area>{{area}}</div> <a data-toggle=collapse data-parent=#accordion href=#{{areaId}} class=\"accordion-toggle collapsed\"></a> </div> <div class=\"content panel-collapse collapse no text-left\" id={{areaId}}> <div ng-transclude></div> </div> </span>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/master/getting-started/views/getting_started_detail_section.html
// module id = 7609901246537008
// module chunks = 1